import React from "react";
import { makeIconDef } from "./makeIconDef";
export var BackIconDef = {
    back: makeIconDef('back', {
        regular: function () { return React.createElement("g", { stroke: "currentColor", strokeWidth: "1", strokeLinecap: "round" },
            React.createElement("path", { d: "M12 2L2 12L12 22", stroke: "currentColor" }),
            React.createElement("path", { d: "M2 12H22", stroke: "currentColor" })); },
        filled: function () { return React.createElement("g", { stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" },
            React.createElement("path", { d: "M12 2L2 12L12 22", stroke: "currentColor" }),
            React.createElement("path", { d: "M2 12H22", stroke: "currentColor" })); },
    })
};
